<template>
  <div>
    <!-- Cabeçalho -->
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="IAF"
            description="Práticas corporais e atividades físicas realizadas na UBS nos últimos 4 meses"
            url="/dashboard"
            :enabledModalInformacao="true"
            :textModalInformacao="text"
          />
        </div>
      </div>

      <!-- Conteúdo: Tabela e área de download -->
      <div class="row">
        <div class="col-md-12">
          <div class="info-table">
            <div class="info-table-item download-right">
              <!-- <download-files :callback-pdf="generatePdf" :data="exportedXlsData" :fields="exportXlsFields"
                :name="mainExportName" /> -->
              <!-- Adicione este botão extra -->
              <b-dropdown
                variant="secondary"
                size="sm"
                class="ml-2 dropdown-files"
              >
                <template #button-content>
                  <i class="icofont-download"></i> Exportar
                </template>
                <b-dropdown-item @click="generatePdf">
                  <i class="icofont-file-pdf"></i> PDF
                </b-dropdown-item>
                <b-dropdown-item @click="exportarXlsPersonalizado">
                  <i class="icofont-file-excel"></i> XLS
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <v-app class="app-tabela">
            <div class="box" style="margin-top: 0px">
              <v-card class="tabela">
                <v-card-title>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Unidade de Saúde"
                    class="input-bottom"
                    single-line
                    hide-details
                  />
                </v-card-title>
                <v-data-table
                  :mobile-breakpoint="0"
                  :page.sync="currentPage"
                  :server-items-length="filteredRecords.length"
                  :footer-props="{
                    itemsPerPageText: '',
                    'items-per-page-options': [10],
                    'disable-items-per-page': true,
                  }"
                  :loading="loading"
                  loading-text="Carregando, por favor, espere"
                  :headers="dynamicHeaders"
                  :items="currentPageRecords"
                  :single-expand="false"
                  :expanded.sync="expanded"
                  item-key="id"
                  :show-expand="true"
                  class="elevation-1"
                >
                  <!--  footer  -->
                  <template v-slot:[`footer.page-text`]="items">
                    <div class="info-table-item tabela-esus-pec">
                      <b>Fonte:</b> e-SUS PEC, {{ ultimaAtualizacao }}
                    </div>
                    <span class="paginacao">
                      {{ currentPageTotal }} de {{ overallTotal }} atividades
                    </span>
                  </template>

                  <!-- Exibição dos detalhes na linha expandida -->
                  <template v-slot:expanded-item="{ item }">
                    <td colspan="7" class="table-expand-details">
                      <div class="expanded-content">
                        <table
                          class="table table-expand"
                          style="margin: 20px 0"
                        >
                          <thead>
                            <tr>
                              <th>Data</th>
                              <th>Profissional</th>
                              <th>CBO</th>
                              <th>Participantes</th>
                              <!-- Coluna extra para o dropdown -->
                              <th class="export-col">
                                <b-dropdown size="sm" class="dropdown-files">
                                  <template #button-content>
                                    <i class="icofont-download"></i> Exportar
                                  </template>
                                  <b-dropdown-item
                                    @click="exportTeamData(item)"
                                  >
                                    <i class="icofont-file-pdf"></i> PDF
                                  </b-dropdown-item>
                                  <b-dropdown-item @click="exportTeamXls(item)">
                                    <i class="icofont-file-excel"></i> XLS
                                  </b-dropdown-item>
                                </b-dropdown>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(detail, index) in item.details"
                              :key="index"
                            >
                              <td>{{ formatDate(detail.data) }}</td>
                              <td>{{ detail.no_profissional }}</td>
                              <td>
                                {{ detail.co_cbo }}
                                <span
                                  v-b-tooltip.hover.right
                                  :title="detail.no_cbo"
                                  class="icon-tooltip"
                                >
                                  <i class="icofont-info-circle"></i>
                                </span>
                              </td>

                              <td>{{ detail.nu_participantes }}</td>
                              <!-- Célula vazia para manter o alinhamento -->
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </template>

                  <!-- Slots progress, no-data, no-results -->
                  <template v-slot:progress>
                    <v-progress-linear
                      color="blue"
                      :height="10"
                      indeterminate
                    />
                  </template>
                  <template v-slot:no-data>
                    <div class="alert alert-info mb-0">
                      <b>Nenhuma informação encontrada.</b>
                    </div>
                  </template>
                  <template v-slot:no-results style="padding: 0px">
                    <div class="alert alert-info mb-0">
                      <b>Nenhuma informação encontrada.</b>
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </div>
          </v-app>
          <!-- Debug -->
          <!-- <pre>{{ atendimentos }}</pre> -->
        </div>
      </div>
    </div>
    <!-- Rodapé -->
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import * as Functions from './functions.js'
import store from '@/store/store'

export default {
  name: 'IAF',
  metaInfo: {
    title: 'IAF',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    DownloadFiles,
  },
  data() {
    return {
      text: 'Texto de informação',
      atendimentos: [],
      expanded: [],
      loading: false,
      search: '',
      currentPage: 1,
      ultimaAtualizacao: new Date().toLocaleDateString(),
      mainExportName: `IAF_Export_${new Date().toISOString().slice(0, 10)}`,
    }
  },
  computed: {
    filteredRecords() {
      const searchLower = (this.search || '').toLowerCase()
      if (!searchLower) return this.displayedRecords
      return this.displayedRecords.filter(
        (record) =>
          (record.unidade_saude || '').toLowerCase().includes(searchLower) ||
          (record.cnes || '').toString().toLowerCase().includes(searchLower)
      )
    },
    currentPageRecords() {
      const itemsPerPage = 10
      const startIndex = (this.currentPage - 1) * itemsPerPage
      const endIndex = startIndex + itemsPerPage
      return this.filteredRecords.slice(startIndex, endIndex)
    },
    currentPageTotal() {
      return this.currentPageRecords.reduce((total, record) => {
        return (
          total +
          [record.mes1, record.mes2, record.mes3, record.mes4].reduce(
            (sum, mes) => sum + (Number(mes) || 0),
            0
          )
        )
      }, 0)
    },
    overallTotal() {
      return this.filteredRecords.reduce((total, record) => {
        return (
          total +
          [record.mes1, record.mes2, record.mes3, record.mes4].reduce(
            (sum, mes) => sum + (Number(mes) || 0),
            0
          )
        )
      }, 0)
    },
    dynamicDates() {
      const dates = this.atendimentos.map((item) => item.mes_ano)
      const uniqueDates = [...new Set(dates)]
      uniqueDates.sort((a, b) => {
        const [monthA, yearA] = a.split('/').map(Number)
        const [monthB, yearB] = b.split('/').map(Number)
        return new Date(yearA, monthA - 1) - new Date(yearB, monthB - 1)
      })
      // Retorna os últimos 4
      return uniqueDates.slice(-4)
    },

    dynamicHeaders() {
      const baseHeaders = [
        { text: 'CNES', value: 'cnes', filterable: true },
        {
          text: 'Unidade de Saúde',
          value: 'unidade_saude',
          filterable: true,
          cellClass: 'no-wrap unidade-saude',
        },
      ]

      const dateHeaders = this.dynamicDates.map((date, index) => ({
        text: date,
        value: `mes${index + 1}`,
        filterable: false,
      }))

      const expandHeader = { text: '', value: 'data-table-expand' }

      return [...baseHeaders, ...dateHeaders, expandHeader]
    },

    displayedRecords() {
      const grouped = {}

      this.atendimentos.forEach((item) => {
        const key = item.nu_cnes
        if (!grouped[key]) {
          grouped[key] = {
            cnes: item.nu_cnes,
            unidade_saude: item.no_unidade_saude,
            mes1: null,
            mes2: null,
            mes3: null,
            mes4: null,
            details: [],
          }
        }
        const dateIndex = this.dynamicDates.indexOf(item.mes_ano)
        if (dateIndex !== -1) {
          grouped[key][`mes${dateIndex + 1}`] = item.qtd_atvdd_mes
          try {
            const parsedDetails = JSON.parse(item.dados_atvdds)
            grouped[key].details.push(...parsedDetails)
          } catch (e) {
            console.error('Erro ao parsear dados_atvdds:', e)
          }
        }
      })

      return Object.values(grouped).map((record, index) => ({
        id: index,
        ...record,
      }))
    },

    dataFields() {
      let fields = {
        CNES: 'cnes',
        'Unidade de Saúde': 'unidade_saude',
      }
      this.dynamicDates.forEach((date, index) => {
        fields[date] = `mes${index + 1}`
      })
      return fields
    },

    exportedXlsData() {
      const rows = []
      // Para cada registro (equipe)
      this.displayedRecords.forEach((record) => {
        ;(record.details || []).forEach((detail) => {
          const row = {
            CNES: record.cnes,
            'Unidade de Saúde': record.unidade_saude,
            Data: this.formatDate(detail.data),
            Profissional: detail.no_profissional,
            CBO: detail.no_cbo,
            Participantes: detail.nu_participantes,
          }

          if (detail.data) {
            const parts = detail.data.split('-')
            row['MES'] = `${parts[1]}/${parts[0]}`
          } else {
            row['MES'] = ''
          }
          rows.push(row)
        })
      })
      return rows
    },

    exportXlsFields() {
      return {
        CNES: 'CNES',
        'Unidade de Saúde': 'Unidade de Saúde',
        MES: 'MES',
        Data: 'Data',
        Profissional: 'Profissional',
        CBO: 'CBO',
        Participantes: 'Participantes',
      }
    },

    cumulativeArray() {
      let arr = []
      let total = 0
      this.displayedRecords.forEach((record) => {
        const recordTotal =
          (Number(record.mes1) || 0) +
          (Number(record.mes2) || 0) +
          (Number(record.mes3) || 0) +
          (Number(record.mes4) || 0)
        total += recordTotal
        arr.push(total)
      })
      return arr
    },
  },
  watch: {
    search() {
      this.currentPage = 1
    },
  },
  methods: {
    exportarXlsPersonalizado() {
      const cidade = store.state.cidade || 'Cidade'
      const titulo = 'IAF - Incentivo de Atividade Física'
      const descricao_secretaria = 'SECRETARIA MUNICIPAL DE SAÚDE'
      const descricao =
        'Práticas corporais e atividades físicas realizadas na UBS nos últimos 4 meses'
      const dataAtual = new Date().toLocaleDateString()
      const subtitulo = 'Atividades coletivas por Unidade Básica de Saúde'

      const dados = this.exportedXlsData
      const nomeArquivo = this.mainExportName

      Functions.exportarXlsCustomizado(
        dados,
        nomeArquivo,
        cidade,
        titulo,
        descricao_secretaria,
        descricao,
        dataAtual,
        subtitulo
      )
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const [year, month, day] = dateStr.split('-')
      return `${day}/${month}/${year}`
    },
    getPagination(options) {
      this.currentPage = options.page
    },
    async buscarDadosIniciais() {
      this.loading = true
      try {
        const response = await this.$api.get(
          `/app/incentivo-atividade-fisica/${this.cod_ibge}`
        )
        this.atendimentos = response.data
      } catch (error) {
        console.error('Erro ao buscar dados:', error)
      } finally {
        this.loading = false
      }
    },
    exportTeamData(team) {
      Functions.exportTeamPdf(team)
    },
    exportTeamXls(team) {
      const cidade = store.state.cidade || ''
      const titulo = 'IAF - Incentivo de Atividade Física'
      const descricao_secretaria = 'SECRETARIA MUNICIPAL DE SAÚDE'
      const descricao =
        'Práticas corporais e atividades físicas realizadas na UBS nos últimos 4 meses'
      const dataAtual = new Date().toLocaleDateString()

      const subtitulo = `CNES: ${team.cnes}\nUBS: ${
        team.unidade_saude || ''
      }\nAtividades coletivas realizadas na UBS`

      const dados = (team.details || []).map((detail) => ({
        CNES: team.cnes,
        'Unidade de Saúde': team.unidade_saude,
        MES: detail.data
          ? detail.data.split('-').slice(0, 2).reverse().join('/')
          : '',
        Data: this.formatDate(detail.data),
        Profissional: detail.no_profissional,
        CBO: detail.no_cbo,
        Participantes: detail.nu_participantes,
      }))

      const nomeArquivo = `IAF_${team.unidade_saude || 'UBS'}_${team.cnes}`

      Functions.exportarXlsCustomizado(
        dados,
        nomeArquivo,
        cidade,
        titulo,
        descricao_secretaria,
        descricao,
        dataAtual,
        subtitulo
      )
    },

    generatePdf() {
      Functions.generatePdf(this.displayedRecords, this.dynamicDates)
    },
  },
  created() {
    this.cod_ibge = this.$store.state.cod_ibge
    // this.cidadeNome = this.$store.state.cidade;
    this.buscarDadosIniciais()
  },
}
</script>

<style>
.table-expand {
  width: 100%;
  table-layout: auto;
}

.table-expand-details {
  background-color: #f9f9f9;
}

.dropdown-files .btn.dropdown-toggle {
  background-color: #545b62 !important;
  border-color: #4e555b !important;
  color: #fff !important;
}

.dropdown-files .btn.dropdown-toggle:focus,
.dropdown-files .btn.dropdown-toggle:active,
.dropdown-files .btn.dropdown-toggle:not(:disabled):not(.disabled):active,
.dropdown-files .btn.dropdown-toggle:not(:disabled):not(.disabled):focus {
  background-color: #545b62 !important;
  border-color: #4e555b !important;
  box-shadow: none !important;
}

.dropdown-files .dropdown-item:hover,
.dropdown-files .dropdown-item:active {
  background-color: #f5f5f5 !important;
  color: #000 !important;
}

.dropdown-files .dropdown-item {
  color: #545b62 !important;
}

.dropdown-files .dropdown-item i {
  margin-right: 6px;
  color: #545b62 !important;
}

.export-col {
  width: 100px;
  text-align: right;
}

.export-col .dropdown-files {
  display: inline-block;
}

.export-col .dropdown-files .btn {
  white-space: nowrap;
}

.download-right {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.no-wrap {
  white-space: nowrap;
}

.unidade-saude {
  min-width: 200px;
}

.expanded-content {
  max-height: 400px;
  overflow-y: auto;
}
</style>
